module.exports = __webpack_public_path__ + "img/7-seven-log0.286e9bbb.png";